module.exports = __webpack_public_path__ + "img/Oliver.5a9c6f74.jpg";